import React from 'react'
import Navbar from '../Navbar'
import Footer from '../footer/Footer'
import img1 from '../../assets/images/1.png'
import img2 from '../../assets/images/2.png'
import img3 from '../../assets/images/Arrow.png'
const AboutUs = () => {
    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                <h1 style={{ color: 'white', fontWeight: '600' }}>About Us</h1>
            </div>
            <div className='py-5 my-3'>
                <div className='querycard'>
                    {/* <h1 className='text-center'><strong>For General Assistance or Queries</strong></h1> */}
                    <div>
                        <div className='row py-5'>
                            {/* <div className='col'>
                                <div className=' querycarddiv'>
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <img src={img1} width={50}></img>
                                            <p style={{padding:"10px 40px  0px"}}>Call Support</p>
                                        </div>
                                        <div>
                                            <img src={img3} width={50} style={{cursor:"pointer"}}></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col'>
                                <div className=' querycarddiv'>
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <img src={img2} width={50}></img>
                                            <p style={{padding:"10px 40px  0px"}}>Send E-mail</p>
                                        </div>
                                        <div>
                                            <img src={img3} width={50} style={{cursor:"pointer"}}></img>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default AboutUs
